var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H20M16 9H20M20 12H16",
    stroke: "#F2F5F8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5996 2.75H13.3877C13.5284 2.75003 13.6424 2.86424 13.6416 3.00586C13.6261 5.72312 13.6411 10.5097 13.6475 12.249C13.6501 12.9681 14.0863 13.5456 14.6289 13.8477C16.206 14.7255 17.25 16.3578 17.25 18.2109C17.2498 20.969 14.9248 23.25 12 23.25C9.07518 23.25 6.75024 20.969 6.75 18.2109C6.75 16.3586 7.79326 14.7268 9.36914 13.8486C9.91669 13.5434 10.3495 12.9574 10.3496 12.2393V3C10.3496 2.86206 10.4617 2.75021 10.5996 2.75Z",
    stroke: "#F2F5F8",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 3,
    fill: "#F2F5F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.3f5c65706c4a6f051684353fc1fe734f.svg";
export { ForwardRef as ReactComponent };